import { xai } from "@ai-sdk/xai";
import { customProvider } from "ai";

const languageModels = {
  "grok-4-fast-reasoning": xai("grok-4-fast-reasoning"),
  "grok-4-fast-non-reasoning": xai("grok-4-fast-non-reasoning"),
};

export const model = customProvider({
  languageModels,
});

export type modelID = keyof typeof languageModels;

export const MODELS = Object.keys(languageModels);

export const defaultModel: modelID = "grok-4-fast-non-reasoning";
